import { gql } from '@apollo/client'

export const GET_UNREAD_NOTIFICATIONS_COUNT = gql`
  query getUnreadNotificationsCount {
    getUnreadNotificationsCount
  }
`
